/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import page from "page";

/**
 * Internal dependencies
 */
import UserMenuDropdown from "blocks/user-menu-dropdown";
import { checkCurrentPath } from "layout/utils";
import Link from "./link";
import BaseTopbar from "./index";
import { getLayoutId } from "state/dashboard/selectors";
import LocationFilterDropdown from "blocks/location-filter-dropdown";
import SelectReportPopver from "blocks/select-report-popover";
import { getAllLayouts } from "state/dashboard-layouts/selectors";
import { useMediaQuery } from "react-responsive";
import { sortBy } from "lodash";

/**
 * Style dependencies
 */
import "./styles.scss";
import logo from "assets/images/logo_color.png";

const maxLinksBeforeBreak = 4;

const Topbar = ({ layoutId, path, dashboards }) => {
  const sortedDashboards = sortBy(dashboards, "position");

  const isMobile = useMediaQuery({ maxWidth: "1150px" });

  const shownLinks = sortedDashboards.slice(0, maxLinksBeforeBreak);
  const remainingLinks = sortedDashboards.slice(maxLinksBeforeBreak);

  const showMoreDropdown = false == isMobile && remainingLinks.length >= 1 && (
    <>
      <Box className="topbar__seperator" />
      <SelectReportPopver
        dashboardfilterFn={(d) => {
          return remainingLinks.map((l) => l.id).includes(d.id);
        }}
        labelMarkup={`${remainingLinks.length} more...`}
      />
    </>
  );

  const deckNavLinks = (
    <Box className="topbar__links" display="flex" alignItems="center">
      {(isMobile ? sortedDashboards : shownLinks).map((d, i) => {
        return (
          <div className="flex column justify-center  items-center" key={d.id}>
            <Link
              label={d.name}
              selected={d.id == layoutId}
              onClick={() => page(`/decks/${d.id}`)}
            />
            {i < shownLinks.length - 1 && !isMobile && (
              <Box className="topbar__seperator" />
            )}
          </div>
        );
      })}
      {showMoreDropdown}
      {isMobile && (
        <>
          <Link
            label="My Account"
            selected={checkCurrentPath("/me", path)}
            onClick={() => page("/me")}
          />
          <Link label="Logout" onClick={() => page("/logout")} />
        </>
      )}
    </Box>
  );

  const mobileMarkup = (
    <div className="topbar__mobile-content">
      <Box>{deckNavLinks}</Box>
    </div>
  );

  return (
    <BaseTopbar mobileChildren={mobileMarkup}>
      <Box
        position="relative"
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        width="full"
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <img src={logo} alt="Logo" style={{ height: 30, marginRight: 25 }} />
          <div>{deckNavLinks}</div>
        </Box>
        <Box className="gap-3" display="flex" alignItems="center">
          <LocationFilterDropdown />
          <Box className="topbar__seperator" />
          <UserMenuDropdown />
        </Box>
      </Box>
    </BaseTopbar>
  );
};

export default connect((state) => ({
  layoutId: getLayoutId(state),
  dashboards: getAllLayouts(state),
  activeDashboardId: getLayoutId(state),
}))(Topbar);
